import { request, renderFormData, formartBody, requestByAxios } from '@/utils/request';
import { stringify } from 'qs';
import { API_JAVA } from '@/utils/base';

const path = API_JAVA + '/ims';

/**
 * Home Page - 用户登录
 * @param {*} params
 * name
 * password
 */
export async function apiLogin(params) {
    return request(path + '/login', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * Home Page - 用户登录
 * @param {*} params
 * name
 * password
 */
export async function apiSendSmsForAdminLogin(params) {
    return request(path + '/sendSmsForAdminLogin', {
        method: 'POST',
        body: renderFormData(params),
    });
}
/**
 * Home Page - 用户登录
 * @param {*} params
 * name
 * password
 */
export async function apiSendSmsForUserLogin(params) {
    return request(path + '/sendSmsForUserLogin', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * Home Page - 退出登录
 */
export async function apiLogout() {
    return request(path + '/logout', {
        method: 'POST',
    });
}

/**
 * Home Page -按照员工和模块查询权限列表
 * @param {*} params
 * hostId integer
 */
export async function apiAuthListByHost(params) {
    return request(path + '/authListByHost', {
        method: 'POST',
        body: renderFormData(params),
    });
}
/**
 * Company - 查询公司列表（正常启用中的列表）
 */
export async function apiCompanyFindUsedBusiness() {
    return request(path + '/company/findUsedBusiness');
}

/**
 * Company - 查询所有公司
 */
export async function apiCompanyList() {
    return request(path + '/company/list');
}

/**
 * Company - 按照分页查询公司列表
 * @param {*} params
 * currentPage 1
 * pageSize 100
 */
export async function apiCompanyListPage(params) {
    return request(path + '/company/listPage', {
        method: 'POST',
        body: params,
    });
}

/**
 * Company - 按照ID查询公司
 * @param {*} params
 * id
 */
export async function apiCompanyDetail(params) {
    return request(path + '/company/detail?' + stringify(params));
}

/**
 * Company - 新增公司
 * @param {*} params
 */
export async function apiCompanySave(params) {
    return request(path + '/company/save', {
        method: 'POST',
        body: params,
    });
}

/**
 * Company - 更新公司
 * @param {*} params
 */
export async function apiCompanyUpdate(params) {
    return request(path + '/company/update', {
        method: 'POST',
        body: params,
    });
}

/**
 * Company - 删除公司
 * @param {*} params
 * ids string
 */
export async function apiCompanyDelete(params) {
    return request(path + '/company/delete', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * Department - 部门列表含子部门
 * @param {*} params
 * companyId
 */
export async function apiDepartmentListTree(params) {
    return request(path + '/department/listTree', {
        method: 'POST',
        body: params,
    });
}

/**
 * Department - 新增部门
 * @param {*} params
 */
export async function apiDepartmentSave(params) {
    return request(path + '/department/save', {
        method: 'POST',
        body: params,
    });
}

/**
 *  - 获取角色
 * @param {*} params
 */
export async function apiGetRoleList(params) {
    return request(path + '/role/listRole', {
        method: 'POST',
        body: params,
    });
}

/**
 * Department - 更新部门
 * @param {*} params
 */
export async function apiDepartmentUpdate(params) {
    return request(path + '/department/update', {
        method: 'POST',
        body: params,
    });
}

/**
 * Department - 删除部门
 * @param {*} params
 * ids string
 */
export async function apiDepartmentDelete(params) {
    return request(path + '/department/delete', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * Menu - 按照模块id查询菜单（树形）列表
 * @param {*} params
 * hostId   integer 必填
 * menuName string
 */
export async function apiMenuListTree(params) {
    return request(path + '/menu/listTree', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * Menu - 新增菜单
 * @param {*} params
 */
export async function apiMenuSave(params) {
    return request(path + '/menu/save', {
        method: 'POST',
        body: params,
    });
}

/**
 * Menu - 更新菜单
 * @param {*} params
 */
export async function apiMenuUpdate(params) {
    return request(path + '/menu/update', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * Menu - 删除菜单
 * @param {*} params
 * ids string
 */
export async function apiMenuDelete(params) {
    return request(path + '/menu/delete', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * Position - 按照分页查询岗位列表
 * @param {*} params
 */
export async function apiPositionListPage(params) {
    return request(path + '/position/listPage', {
        method: 'POST',
        body: params,
    });
}

/**
 * Position -查询所有岗位
 */
export async function apiPositionList() {
    return request(path + '/position/list', {
        method: 'POST',
    });
}

/**
 * Position - 新增岗位
 * @param {*} params
 */
export async function apiPositionSave(params) {
    return request(path + '/position/save', {
        method: 'POST',
        body: params,
    });
}

/**
 * Position - 编辑岗位
 * @param {*} params
 */
export async function apiPositionUpdate(params) {
    return request(path + '/position/update', {
        method: 'POST',
        body: params,
    });
}

/**
 * Position - 删除岗位
 * @param {*} params
 * ids string
 */
export async function apiPositionDelete(params) {
    return request(path + '/position/delete', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * User - 修改密码
 * @param {*} params
 * originPassword
 * newPassword
 */
export async function apiUserChangePassword(params) {
    return request(path + '/user/changePassword', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * User - 按照分页查询员工列表
 * @param {*} params
 */
export async function apiUserListPage(params) {
    return request(path + '/user/listPage', {
        method: 'POST',
        body: params,
    });
}

/**
 * User - 新增员工
 * @param {*} params
 */
export async function apiUserSave(params) {
    return request(path + '/user/save', {
        method: 'POST',
        body: params,
    });
}

/**
 * User - 启用禁用员工
 * @param {*} params
 */
export async function apiUserUsed(params) {
    return request(path + '/user/used', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * User - 编辑员工
 * @param {*} params
 */
export async function apiUserUpdate(params) {
    return request(path + '/user/update', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * User - 修改员工密码
 * @param {*} params
 */
export async function apiUserSetPassword(params) {
    return request(path + '/user/setPassword', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * User - 启用或停用员工
 * @param {*} params
 * ids string
 * status string
 */
export async function apiUserChangeStatus(params) {
    return request(path + '/user/changeStatus', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * User - 设置权限
 * @param {*} params
 * userId integer
 * hostId integer
 * ids string
 */
export async function apiUserSetPermission(params) {
    return request(path + '/user/setPermission', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * User - 根据模块获取当前用户的权限列表
 * @param {*} params
 * userId
 * hostId
 */
export async function apiUserInitPermission(params) {
    return request(path + '/user/initPermission?' + stringify(params));
}

/**
 * User - 根据部门查用户
 * @param {*} params
 */
export async function apiListUserByDepart(params) {
    return request(path + '/user/listUserByDepart', {
        method: 'POST',
        body: renderFormData(params),
    });
}


/**
 * Home Page - 获取全部的host
 */
export async function apiGetAllHost() {
    return request(path + '/getAllHost');
}

/**
 * User - 删除银行卡
 * id - 银行卡id
 */
export async function apiBankCodeCelete(params) {
    return request(path + '/bankcard/delete', {
        method: 'POST',
        body: renderFormData(params),
    });
}

/**
 * User -新增银行卡
 * id - 银行卡id
 * cardNumber - 银行卡号
 * companyId - 公司id
 * cardBank - 所属银行
 * cardPlace - 开户行
 */
export async function apiBankCodeSave(params) {
    return request(path + '/company/saveBankAccount', {
        method: 'POST',
        body: params,
    });
}

/**
 * User - 编辑保存银行卡
 * id - 银行卡id
 * cardNumber - 银行卡号
 * companyId - 公司id
 * cardBank - 所属银行
 * cardPlace - 开户行
 */
export async function apiBankCodeUpdate(params) {
    return request(path + '/company/disableBankAccount?id=' + params.id, {
        method: 'get',
        body: params,
    });
}

/**
 * 启用公司
 */
export async function apiCompanyEnable(params) {
    return request(path + '/company/enable?id=' + params.id, {
        method: 'GET',
        params: params,
    });
}

/**
 * 禁用公司
 */
export async function apiCompanyDisable(params) {
    return request(path + '/company/disable?id=' + params.id, {
        method: 'GET',
        params: params,
    });
}

/**
 * 查询省市
 */
export async function apiProvinceCity() {
    return request(path + '/area/listTree', {
        method: 'POST',
    });
}

/**
 * 查询市区
 */
export async function apiCity() {
    return request(path + '/area/listCitysTree', {
        method: 'GET',
    });
}

/**
 * 文件上传
 */
export async function uploadFile(params) {
    return request(path + '/uploadFile', {
        method: 'POST',
        header: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
        },
        body: params,
    });
}

/**
 * User - 获取用户的所有下属及自己
 * @param {*} params
 */
export async function apiCurrentUserListPairs(params) {
    return request(path + '/user/listPairs', {
        method: 'post',
        body: params,
    });
}
/**
 * Home Page - 我的下属列表
 * @param {*} params
 * name
 * password
 */
export async function apiCurrentAllUserListPairs(params) {
    return request(path + '/user/listAllPairs', {
        method: 'POST',
        body: params,
    });
}


// WEBPACK FOOTER //
// ./src/services/ims.js